import { useCallback } from 'react'
import { RiText, RiHeading, RiFontSize } from 'react-icons/ri'
import { getCanvasInstance } from '@/lib/canvasInstance'
import { useEditorStore } from '@/stores/useEditorStore'
import styles from './TextPanel.module.css'

const textPresets = [
    {
        id: 'heading',
        icon: RiHeading,
        label: 'Titulo',
        config: { text: 'Titulo', fontSize: 48, fontWeight: 'bold', fontFamily: 'Arial' },
    },
    {
        id: 'subheading',
        icon: RiFontSize,
        label: 'Subtitulo',
        config: { text: 'Subtitulo', fontSize: 32, fontWeight: '600', fontFamily: 'Arial' },
    },
    {
        id: 'body',
        icon: RiText,
        label: 'Texto',
        config: { text: 'Escribe tu texto aqui', fontSize: 18, fontWeight: 'normal', fontFamily: 'Arial' },
    },
]

export function TextPanel() {
    const { pushUndo } = useEditorStore()

    const addText = useCallback(async (config: typeof textPresets[number]['config']) => {
        const canvas = getCanvasInstance()
        if (!canvas) return

        const fabric = await import('fabric')
        const text = new fabric.IText(config.text, {
            left: 100,
            top: 100,
            fontSize: config.fontSize,
            fontWeight: config.fontWeight,
            fontFamily: config.fontFamily,
            fill: '#171c1c',
            editable: true,
        })

        canvas.add(text)
        canvas.setActiveObject(text)
        canvas.requestRenderAll()

        const json = JSON.stringify(canvas.toJSON())
        pushUndo(json)
    }, [pushUndo])

    const handleDragStart = useCallback((e: React.DragEvent, config: typeof textPresets[number]['config']) => {
        e.dataTransfer.setData('application/x-editor-element', JSON.stringify({
            type: 'text',
            config,
        }))
        e.dataTransfer.effectAllowed = 'copy'
    }, [])

    return (
        <div className={styles.panel}>
            <h3 className={styles.title}>Texto</h3>
            <div className={styles.presets}>
                {textPresets.map((preset) => (
                    <button
                        key={preset.id}
                        className={styles.presetButton}
                        onClick={() => addText(preset.config)}
                        draggable
                        onDragStart={(e) => handleDragStart(e, preset.config)}
                    >
                        <preset.icon className={styles.presetIcon} />
                        <span>{preset.label}</span>
                    </button>
                ))}
            </div>
        </div>
    )
}
